import { useRef, useEffect } from "react";

export function useDropdownManager({ isOpen, dropdownRef, setIsOpen }) {
  useEffect(() => {
    if (!isOpen) return;

    const closeOtherDropdowns = () => {
      document
        .querySelectorAll(".quantity-dropdown--open")
        .forEach((dropdown) => {
          if (dropdown !== dropdownRef.current) {
            const event = new CustomEvent("closeDropdown");
            dropdown.dispatchEvent(event);
          }
        });
    };

    const handleClose = () => setIsOpen(false);
    dropdownRef.current?.addEventListener("closeDropdown", handleClose);

    closeOtherDropdowns();

    return () => {
      dropdownRef.current?.removeEventListener("closeDropdown", handleClose);
    };
  }, [isOpen, dropdownRef, setIsOpen]);
}

/*
 * Hook to handle the height adjustment of cart list when dropdown is open on mobile
 * Automatically expands the cart's height to fit the dropdown content
 * and restores the original height when closed
 */
export function useCartListHeight({ isOpen, source, dropdownRef, onClose }) {
  const heightRef = useRef({ didAdjust: false, original: null });

  useEffect(() => {
    if (!isOpen) return;

    const cartList = document.querySelector(".cart-item-list");
    if (
      cartList &&
      source === "cart" &&
      window.matchMedia("(max-width: 940px)").matches
    ) {
      const dropdownHeight = dropdownRef.current?.querySelector(
        ".quantity-dropdown__list",
      )?.offsetHeight;
      if (dropdownHeight) {
        heightRef.current = {
          didAdjust: true,
          original: cartList.style.height,
        };
        const newHeight = `${cartList.clientHeight + dropdownHeight}px`;
        cartList.style.height = newHeight;
        cartList.style.maxHeight = newHeight;
      }
    }

    document.addEventListener("mousedown", onClose);
    return () => {
      document.removeEventListener("mousedown", onClose);
      if (heightRef.current.didAdjust && cartList) {
        cartList.style.height = heightRef.current.original;
        cartList.style.maxHeight = heightRef.current.original;
      }
    };
  }, [isOpen, source, dropdownRef, onClose]);
}
